export const fetchGQL = <T>(query: string, token?: string): Promise<T> =>
  fetch(`${process.env.APPLICATION_API_URL}/graphql`, {
    credentials: "same-origin",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ query }),
  })
    .then(res => {
      if (!res.ok) {
        throw new Error(res.statusText);
      }
      return res.json();
    })
    .then(({ data }) => data)
    .catch((e: Error) => {
      throw e;
    });
